const useGetNameInitials = () => {

    return (name = "") => {
        return name ? name?.split(" ")?.map(elm => elm[0])?.join("")?.toUpperCase()?.slice(0, 2) : "";
    }
}

export default useGetNameInitials